import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { NotFoundModule } from 'app/modules/not-found/not-found.module';
import { Subject } from 'rxjs';
import { PageRibbonComponent } from '../../../shared/components/profiles/page-ribbon.component';

@Component({
	selector: 'empty-layout',
	templateUrl: './empty.component.html',
	encapsulation: ViewEncapsulation.None,
	imports: [FuseLoadingBarComponent, NgIf, RouterOutlet, NotFoundModule, PageRibbonComponent],
	standalone: true,
})
export class EmptyLayoutComponent implements OnInit, OnDestroy {
	state: string = '';
	private _unsubscribeAll: Subject<any> = new Subject<any>();

	/**
	 * Constructor
	 */
	constructor(private _activatedRoute: ActivatedRoute) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.state = '';
		this._activatedRoute.data.subscribe((params) => {
			this.state = params.state;
		});
	}
	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}
}
